export default {
  site_title: "OOPBuy Spreadsheet Deutschland – Die komplette Produktliste & Anleitung",
  site_description: "OOPBuy Spreadsheet Deutsch erklärt. Finde Produkte, Preise, Kategorien und sichere Shopping Tipps. Die komplette Übersicht für deutsche Nutzer.",
  hero_title_1: "OOPBuy Spreadsheet",
  hero_title_2: "Die komplette",
  hero_title_3: "Übersicht für Deutschland",
  hero_subtitle: "Finde Produkte schneller, vergleiche Preise und entdecke die besten Möglichkeiten mit dem OOPBuy Spreadsheet.",
  cta_primary: "OOPBuy Spreadsheet ansehen",
  cta_secondary: "Komplette Anleitung lesen",
  trust_1: "Deutsche Anleitung",
  trust_2: "Aktualisierte Produktlisten",
  trust_3: "Sicherheitsinformationen",
  trust_4: "Schritt-für-Schritt Erklärung",
  about_title: "Was ist OOPBuy Spreadsheet?",
  why_title: "Warum OOPBuy Spreadsheet besser ist",
  how_title: "So funktioniert OOPBuy Spreadsheet",
  categories_title: "OOPBuy Spreadsheet Kategorien",
  security_title: "Ist OOPBuy Spreadsheet sicher?",
  faq_title: "Häufig gestellte Fragen",
  nav_home: "Startseite",
  nav_guide: "Shopping Guide",
  nav_categories: "Kategorien",
  nav_security: "Sicherheit",
  nav_blog: "Blog",
  nav_articles: "SEO Ratgeber",
  seo_articles_title: "OOPBuy Spreadsheet – Alle Ratgeber",
  seo_articles_desc: "Entdecke unsere ausführlichen SEO-Ratgeber rund um das OOPBuy Spreadsheet. Von Sicherheit über Preisvergleich bis zu Kategorie-Guides.",
  back_home: "Zurück zur Startseite",
  read_more: "Weiterlesen",
  footer_brand: "OOPBuy Spreadsheet",
  footer_desc: "Deine unabhängige deutsche Informationsplattform für sicheres und effizientes China Shopping.",
  footer_copyright: "© 2026 OOPBuy Spreadsheet. Alle Rechte vorbehalten.",
  footer_newsletter: "Bleib auf dem Laufenden",
  footer_newsletter_desc: "Erhalte die neuesten Tipps und Updates zum OOPBuy Spreadsheet.",
  footer_subscribe: "Abonnieren",
  footer_email_placeholder: "Deine E-Mail-Adresse",
  view_main_site: "Zur Hauptwebsite",
  buy_now: "Jetzt entdecken",
};